import apiClient from './apiClient';

const contactPortalService = {
  async register(payload) {
    const response = await apiClient.post('/api/contact-portal/register/', payload);
    return response.data;
  },

  async login(email, password) {
    const response = await apiClient.post('/api/contact-portal/login/', {
      email,
      password
    });
    return response.data;
  },

  async logout() {
    await apiClient.post('/api/contact-portal/logout/');
  },

  async me() {
    const response = await apiClient.get('/api/contact-portal/me/');
    return response.data;
  },

  async getTasks() {
    const response = await apiClient.get('/api/contact-portal/tasks/');
    return response.data.results || [];
  },

  async getTaskById(taskId) {
    const response = await apiClient.get(`/api/contact-portal/tasks/${taskId}/`);
    return response.data;
  },

  async getTaskChatMessages(taskId) {
    const response = await apiClient.get(`/api/contact-portal/tasks/${taskId}/chat/`);
    return response.data || [];
  },

  async createTaskChatMessage(taskId, message) {
    const response = await apiClient.post(`/api/contact-portal/tasks/${taskId}/chat/`, {
      message
    });
    return response.data;
  },

  async getTaskAttachments(taskId) {
    const response = await apiClient.get(`/api/contact-portal/tasks/${taskId}/attachments/`);
    return response.data || [];
  },

  async uploadTaskAttachment(taskId, file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(
      `/api/contact-portal/tasks/${taskId}/attachments/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  async checkEmail(email) {
    const response = await apiClient.post('/api/contact-portal/email-check/', { email });
    return response.data;
  },

  async createIframeTask(payload) {
    const response = await apiClient.post('/api/contact-portal/iframe-tasks/', payload);
    return response.data;
  },

  async activateAccount(uid, token, password, passwordConfirm) {
    const response = await apiClient.post('/api/contact-portal/activate/', {
      uid,
      token,
      password,
      password_confirm: passwordConfirm
    });
    return response.data;
  },

  async resendActivation(email) {
    const response = await apiClient.post('/api/contact-portal/resend-activation/', { email });
    return response.data;
  },

  async requestPasswordReset(email) {
    const response = await apiClient.post('/api/contact-portal/password-reset-request/', { email });
    return response.data;
  },

  async confirmPasswordReset(uid, token, password, passwordConfirm) {
    const response = await apiClient.post('/api/contact-portal/password-reset-confirm/', {
      uid,
      token,
      password,
      password_confirm: passwordConfirm
    });
    return response.data;
  }
};

export default contactPortalService;
